import React from "react";
import { Card, CardContent } from "../ui/card";
import { Shield, User, AlertCircle, BarChart3 } from "lucide-react";

const ControlStats = ({ controls }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Total Controls
              </p>
              <p className="text-2xl font-bold">{controls.length}</p>
            </div>
            <Shield className="h-8 w-8 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Assigned
              </p>
              <p className="text-2xl font-bold text-foreground">
                {
                  controls.filter(
                    (control) =>
                      (control.assigned_users &&
                        control.assigned_users.length > 0) ||
                      control.Assignee
                  ).length
                }
              </p>
            </div>
            <User className="h-8 w-8 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Unassigned
              </p>
              <p className="text-2xl font-bold text-foreground">
                {
                  controls.filter(
                    (control) =>
                      (!control.assigned_users ||
                        control.assigned_users.length === 0) &&
                      !control.Assignee
                  ).length
                }
              </p>
            </div>
            <AlertCircle className="h-8 w-8 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Effective
              </p>
              <p className="text-2xl font-bold text-foreground">
                {
                  controls.filter(
                    (control) => control.effectiveness === "effective"
                  ).length
                }
              </p>
            </div>
            <BarChart3 className="h-8 w-8 text-muted-foreground" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ControlStats;
